import { combineReducers } from 'redux'
import { settingsReducer } from '../settings/reducer';

export const rootReducer = (history) => {
  return combineReducers({
    settings: settingsReducer
})}